import { Component, Vue } from "vue-property-decorator";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import { gql } from "graphql-tag";
import { CONTINUING_EDUCATION } from "@/graphql/user-continuing-education-query";
import { CountinuingEducation } from "@/models/user-continuing-education/user-continuing-education.interface";
import { utils } from "@/utils/utils";
import DateRangePicker from "@/components/date-range-picker-local/components/DateRangePicker.vue";
import FileUploadComponent from "../file-upload/file-upload.component.vue";
import { applicantDetialsApi } from "@/providers/apis/applicant-dashboard";
import PreviewPopupComponent from "../preview-popup/preview-popup.component.vue";
import { appConfigService } from "@/providers/services/app/app-config";
import ErrorPopupComponent from "../error-popup/error-popup.component.vue";
import moment from "moment";
import FormInputDatepickerComponent from "../form-input-datepicker/form-input-datepicker.component.vue";
import RadioButtonComponent from "../radio-button/radio-button.component.vue";
import SuccessPopupComponent from "../success-popup/success-popup.component.vue";
@Component({
  name: "user-continuing-education",
  components: {
    AppLoaderComponent,
    DateRangePicker,
    PreviewPopupComponent,
    "b-form-upload-file": FileUploadComponent,
    ErrorPopupComponent,
    "b-form-input-datepicker": FormInputDatepickerComponent,
    "b-form-radio-group": RadioButtonComponent,
    SuccessPopupComponent,
  },
})
export default class UserEducationComponent extends Vue {
  public addEducation = false;
  public isFileValid = false;
  public checkValidation = false;
  public vaildFile = false;
  public isLoading = true;
  public showPreviewPopup = false;
  public isDataEmpty = false;
  public educationLists: any = [];
  public imgType = ["jpg", "png", "jpeg", "tiff", "pdf"];
  public S3Path = "";
  public educationFormDetials: CountinuingEducation[] = [];
  public notFilesUploadedKeyNames: string[] = [];
  public files: File[] = [];
  public previewFile: any = {};
  public eventBind: any = {
    acceptNumberOnly: this.numberValidation,
    telCharacter: this.telCharacterValidate,
  };
  public educationData: any;
  public addNewEducationForm: any = {
    title: "",
    trainingDate: "",
    description: "",
    proofOfAttendance: [],
  };
  public errorMessage = "";
  public educationActiveLists: any[] = [];
  public formSelected = "continuing education";
  public archivedData: any = {};
  public successMsg = "";

  public created() {
    this.S3Path = appConfigService.getS3FilesPathUrl();
    this.$apollo
      .query({
        query: gql`query ${CONTINUING_EDUCATION}`,
      })
      .then((result) => {
        this.educationFormDetials = result.data.continuingEducations.data;
        this.educationFormDetials = this.educationFormDetials.filter(
          (data) => data.attributes.form_name === "continuingEducation"
        );
      });
    this.onGetContinuingEducation();
  }
  public addCertificationForm() {
    this.addEducation = true;
  }
  public closeSidebar() {
    this.addEducation = false;
  }

  public hidePreviewPopup(event: boolean) {
    if (event === true) {
      this.showPreviewPopup = false;
      this.previewFile = [];
    }
  }

  public get isTitleDuplicate() {
    const newTitle = this.addNewEducationForm.title?.trim();
    if (!newTitle) return false;
    return this.educationLists?.some(
      (edu: any) => !edu.isArchived && edu.title?.trim() === newTitle
    );
  }

  public async applicationSubmit() {
    this.checkValidation = true;
    this.isFileValid = !this.isFileValid;
    if (this.isTitleDuplicate) {
      this.errorMessage =
        "A continuing education with this title already exists.";
      return;
    }
    this.$validator.validate().then((validate: any) => {
      // Attachment is mandatory (NOT NULL in DB) — don't rely only on the
      // CMS-driven file validation, which may not mark the field required.
      if (validate && !this.addNewEducationForm.proofOfAttendance?.length) {
        this.errorMessage = "Please upload proof of attendance.";
        return;
      }
      if (validate && this.vaildFile) {
        this.isLoading = true;

        const formdata = new FormData();
        formdata.append("title", this.addNewEducationForm.title);
        formdata.append("description", this.addNewEducationForm.description);
        formdata.append("trainingDate", this.addNewEducationForm.trainingDate);
        formdata.append(
          "trainingHours",
          this.addNewEducationForm.trainingDuration
            ? this.addNewEducationForm.trainingDuration
            : ""
        );
        formdata.append(
          "trainingFormat",
          this.addNewEducationForm.trainingFormat
            ? this.addNewEducationForm.trainingFormat
            : ""
        );
        for (
          let index = 0;
          index < this.addNewEducationForm.proofOfAttendance.length;
          index++
        ) {
          formdata.append(
            "files",
            this.addNewEducationForm.proofOfAttendance[index]
          );
        }
        applicantDetialsApi
          .createContinuingEducation(formdata)
          .then((data) => {
            if (data) {
              this.onGetContinuingEducation();
              this.addEducation = false;
              this.vaildFile = false;
              this.addNewEducationForm = {
                title: "",
                trainingDate: "",
                description: "",
                proofOfAttendance: [],
              };
              this.isLoading = false;
            }
          })
          .catch((error) => {
            this.errorMessage = utils.errorMessage(error);
            this.isLoading = false;
          });
      } else {
        const el = document.getElementsByClassName("is-invalid")[0];
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "end" });
        }
      }
    });
  }

  public previewForm(rowData: any) {
    rowData.attachments.forEach((item: any) => {
      item.uploadedFileName = item.fileName;
      const temp = JSON.parse(JSON.stringify(item));
      const previewData = temp;
      if (this.imgType.includes(previewData.uploadedFileName.split(".")[1])) {
        const img = new Image();
        img.src = `${this.S3Path}/${previewData.uploadedFileName}`;
        previewData.width = img.width;
        previewData.height = img.height;
      }
      if (!this.previewFile.length) {
        this.previewFile = [previewData];
      } else {
        this.previewFile.push(previewData);
      }
      this.showPreviewPopup = true;
    });
  }

  public onGetContinuingEducation() {
    this.isLoading = true;
    applicantDetialsApi
      .getContinuingEducation()
      .then((result) => {
        this.educationLists = result.data.educations;
        this.educationLists.map((item: any) => {
          item.trainingDate = item.trainingDate
            ? moment(item.trainingDate).format("MM-DD-YYYY")
            : null;
        });
        this.educationActiveLists = this.educationLists.filter((list: any) => {
          return this.formSelected === "continuing education"
            ? list.isArchived === false
            : list.isArchived === true;
        });
        if (this.educationActiveLists.length) {
          this.isDataEmpty = false;
        } else {
          this.isDataEmpty = true;
        }
        this.isLoading = false;
      })
      .catch((error) => {
        this.isDataEmpty = true;
        this.errorMessage = utils.errorMessage(error);
        this.isLoading = false;
      });
  }

  public closePopup() {
    this.$bvModal.hide("error-modal-center");
  }

  public numberValidation(evt: Event, length?: number) {
    utils.onlyNumberKey(evt, length);
  }

  public telCharacterValidate(evt: any, length?: number) {
    utils.telCharacterValidate(evt, length);
  }

  public avoidNumbersAndSpecialCharacter(evt: any) {
    utils.avoidNumbersAndSpecialCharacters(evt);
  }

  public fileValid(event: any) {
    this.vaildFile = event;
  }

  public notFileUploaded(event: string) {
    if (!this.notFilesUploadedKeyNames.includes(event)) {
      this.notFilesUploadedKeyNames.push(event);
    }
  }

  public allFilesUploaded(event: any) {
    if (this.notFilesUploadedKeyNames.includes(event)) {
      this.notFilesUploadedKeyNames.splice(event, 1);
    }
  }

  public closdedErrorPopup(event: any) {
    if (event) {
      this.errorMessage = "";
      this.$nextTick(() => {
        const el = document.querySelector("#trainingForm .is-invalid");
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    }
  }
  public archiveForm(rowData: any, type: any) {
    this.archivedData = {
      title: rowData.title,
      id: rowData.id,
      archive: type,
    };
    this.$bvModal.show("conformation-popup");
  }
  public formSelection(formSelect: string) {
    this.formSelected = formSelect;
    if (this.formSelected === "continuing education") {
      this.educationActiveLists = this.educationLists.filter((list: any) => {
        return list.isArchived === false;
      });
    } else {
      this.educationActiveLists = this.educationLists.filter((list: any) => {
        return list.isArchived;
      });
    }
    if (this.educationActiveLists.length) {
      this.isDataEmpty = false;
    } else {
      this.isDataEmpty = true;
    }
  }
  public cancelConfirmPopup() {
    this.$bvModal.hide("conformation-popup");
  }
  public submitConfirmCetrificate() {
    this.$bvModal.hide("conformation-popup");
    const data = {
      id: this.archivedData.id,
      archive: this.archivedData.archive,
    };
    applicantDetialsApi.archivedEducation(data).then(() => {
      const archivedMsg = this.archivedData.archive ? "archived" : "unarchived";
      this.successMsg = `${this.archivedData.title} has been ${archivedMsg}.`;
      this.onGetContinuingEducation();
    });
  }
  public closedSuccessPopup() {
    this.successMsg = "";
  }
}
